export const operationSystems = ['Windows', 'Mac'];

export const nodeConfig = {
  virtualNodeWidth: 66,
  nodeWidth: 240, // px
  nodeHeight: 68, // px
};

export const API_CALL_DEBOUNCE_TIME = 500;
